export const noop = () => {};
export const asyncNoop = async () => Promise.resolve();
export const emptyObject = {} as any;
export const emptyArray = [] as any[];
export const emptySet = new Set([]);
export const ellipsis = {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
};

export const DISABLED_SCROLL_BUTTON_SX = {
  '.MuiTabs-scrollButtons.Mui-disabled': {
    opacity: 0.3,
  },
};
